<div class="primary__card">
  <h5>{{ 'Yarn_Details_Composition_Title' | translateWF: 'Composition' }}</h5>
  <br />

  @if (fabricComposition && fabricComposition.length > 0) {
    <!-- Dynamic color bar -->
    <div class="sample-color">
      <div
        *ngFor="let comp of fabricComposition"
        class="sample-color__item"
        [style.width.%]="comp.percentage"
        [style.background-color]="getCompositionColor(comp.compositionCode)"
      ></div>
    </div>
    <br /><br />

    <!-- Dynamic composition info -->
    <div class="info-compostion">
      <div class="info-composition__item" *ngFor="let comp of fabricComposition">
        <div>
          <span [style.background-color]="getCompositionColor(comp.compositionCode)"></span>
          <p>
            {{ getCompositionName(comp.compositionCode) }}
          </p>
        </div>
        <p>{{ comp.percentage }}%</p>
      </div>
    </div>
  } @else {
    <p>
      {{ 'Yarn_Details_No_Compositions' | translateWF: 'No yarns added yet' }}
    </p>
  }
</div>
